import Vue from 'vue'
import { Resp } from '~/plugins/_helpers'

// import { scrollTo } from "gsap/ScrollToPlugin";

export const Helper = {
  data() {
    return {
      isDesktop: Resp.isDesktop,
      isTablet: Resp.isTablet,
      isMobile: Resp.isMobile,
      _debounce: null,
      debug: true
    }
  },
  methods: {
    /**
     * @param {*} arg - Array of data for console
     * @param {String} cssStyle - css style for console
     */
    $log(arg, cssStyle, table) {
      if (!this.debug) return

      console.log(
        `%cComponent: ${this.$options.name}`,
        'background-color: #333333; color: #eeeeee; padding: 2px 7px'
      )

      if (cssStyle) {
        console.log(`%c${arg}`, cssStyle)
      } else if (table) {
        console.table(arg)
        return
      } else {
        console.log(arg)
      }
    },

    setResp() {
      clearTimeout(this._debounce)
      this._debounce = setTimeout(() => {
        this.defaultResp()
      }, 50)
    },

    defaultResp() {
      Vue.set(this, 'isDesktop', Resp.isDesktop)
      Vue.set(this, 'isTablet', Resp.isTablet)
      Vue.set(this, 'isMobile', Resp.isMobile)
    },
    // scrollToContacts(el, offsetY = 0, onComplete) {
    //   if (!process.browser || !el) return;

    //   TweenMax.to(window, 1.2, {
    //     scrollTo: { y: el, autoKill: false, offsetY },
    //     onComplete,
    //     ease: Power2.easeInOut
    //   });
    // },
    //Locale Storage
    setLocalStorageObjectItem(key, value) {
      if (value === undefined) {
        localStorage.removeItem(key)
      } else {
        localStorage.setItem(key, JSON.stringify(value))
      }
    },

    getLocalStorageObjectItem(key) {
      const json = localStorage.getItem(key)
      if (json === null) {
        return
      }
      return JSON.parse(json)
    },

    //Session Storage
    setSessionStorageObjectItem(key, value) {
      if (value === undefined) {
        sessionStorage.removeItem(key)
      } else {
        sessionStorage.setItem(key, JSON.stringify(value))
      }
    },

    getSessionStorageObjectItem(key) {
      const json = sessionStorage.getItem(key)
      if (json === null) {
        return
      }
      return JSON.parse(json)
    },
    getDataFromGlobal(index, isObject) {
      const obj = Object.assign({}, this.$t('global.components')[index])
      delete obj['componentName']
      if (isObject) {
        return obj
      } else {
        const arr = Object.keys(obj).map(k => obj[k])
        return arr
      }
    }
  },
  mounted() {
    if (!process.browser) return

    window.onNuxtReady(() => {
      this.defaultResp()
      this.setResp()
    })

    window.addEventListener('resize', this.setResp, false)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setResp)
  }
}



// WEBPACK FOOTER //
// ./mixins/Helper.js